/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import './src/fonts.scss'

//export const onPreRouteUpdate = ( params ) => {
//  console.log( 'gatsby-browser.onPreRouteUpdate', params );
//}
//
//export const onRouteUpdate = ( params ) => {
//  console.log( 'gatsby-browser.onRouteUpdate', params );
//}
